import React from 'react';
import { Helmet } from 'react-helmet';
import styled, { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { StateInspector } from 'reinspect';
import { GlobalStyles } from '@service-victoria/component-library/utils/globalStyles';
import { FeatureTogglesProvider } from 'context/FeatureTogglesProvider';
import Routes from 'routes';
import { themes } from 'utils';
import { app as Context } from 'context';

const Wrapper = styled.div``;

const App: React.FC = () => {
  // load the previous saved context if there was any
  const { currentState } = Context.useAppContext();
  return (
    <Wrapper>
      <ThemeProvider theme={themes.primary}>
        <GlobalStyles />
        <Helmet />
        <StateInspector name='App'>
          <Router basename={process.env.REACT_APP_BASENAME}>
            <QueryParamProvider ReactRouterRoute={Route}>
              <FeatureTogglesProvider>
                <Context.AppProvider state={currentState} id='App'>
                  <Routes />
                </Context.AppProvider>
              </FeatureTogglesProvider>
            </QueryParamProvider>
          </Router>
        </StateInspector>
      </ThemeProvider>
    </Wrapper>
  );
};
export default App;
